import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0zm0 1.2c1.935 0 3.704.712 5.068 1.883L3.083 14.069A7.766 7.766 0 0 1 1.2 9c0-4.301 3.499-7.8 7.8-7.8zm0 15.6a7.756 7.756 0 0 1-5.068-1.883L14.917 3.931A7.766 7.766 0 0 1 16.8 9c0 4.301-3.499 7.8-7.8 7.8z" />
  </svg>
);

export default SvgComponent;
